function u(n) {
  return n == null ? "null" : typeof n == "function" ? "a function" : `'${n}'`;
}
function f(n, o, r) {
  if (!r)
    return o;
  const t = typeof r == "function" ? r(n, o) : n == null ? void 0 : n[r];
  if (t == null)
    throw new Error(`Key is ${t} on item (keyField is ${u(r)})`);
  return t;
}
function e(n, o, r) {
  if (typeof r == "function" && o == null)
    throw new Error("index is required when using a function keyField");
  return f(n, o ?? 0, r);
}
export {
  e as a,
  f as r
};
//# sourceMappingURL=keyField-D6okV6nC.js.map
